import { IPaymentFields, IPaymentMethod, IShipwallet } from '@checkout/state';
import { IStepDataModel } from '@checkout/steps';
import { IntlProvider } from 'react-intl';
import { DeliveryOptions, IngridFieldsForm, IngridWidget2, KlarnaCheckout, PaymentOptions, PersonalInformation } from '..';
import messages from '../../../i18n/base-en';
import { isOnlyKlarnaCheckout } from '../../../utils/paymentMethods';
// import getValidationSchema from './../CheckoutForm/CheckoutFormFormValidationSchema';
// import ValidationSchemaNames from './../CheckoutForm/ValidationSchemaNames';

export const getStepsList = (
  shipwallet: IShipwallet,
  intlData: IntlProvider.Props,
  fields: IPaymentFields,
  paymentMethods: IPaymentMethod[],
  isIngridFieldsVisible: boolean): IStepDataModel[] => {

  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;
  const isOnlyKCO = isOnlyKlarnaCheckout(paymentMethods);

  return [
    {
      shouldRender: isIngridFieldsVisible && shipwallet !== undefined && shipwallet.version === 2, // Shipwallet version 2 with IngridFields workaround
      title: formatMessage(messages.ingrid_fields_step_title),
      component: IngridFieldsForm,
      // validationSchema: getValidationSchema(intlData, fields, [ValidationSchemaNames.ingridFields])
    },
    {
      shouldRender: !shipwallet, // !shipwallet || countries.length > 1
      title: formatMessage(messages.address_step_title),
      component: PersonalInformation,
      buttonLabel: formatMessage(messages.address_step_button_title),
      // validationSchema: getValidationSchema(intlData, fields, [ValidationSchemaNames.shippingAddress, ValidationSchemaNames.contactDetails])
    },
    {
      shouldRender: shipwallet === undefined, // Standard multiple delivery options or not shipwallet
      title: formatMessage(messages.shipping_step_title),
      component: DeliveryOptions,
      buttonLabel: formatMessage(messages.shipping_step_button_title),
    },
    {
      shouldRender: !isIngridFieldsVisible && shipwallet !== undefined && shipwallet.version === 2, // Shipwallet version 2
      title: formatMessage(messages.shipwallet_step_title),
      component: IngridWidget2,
      buttonLabel: formatMessage(messages.shipwallet_step_button_title),
    },
    {
      shouldRender: !isOnlyKCO, // Standard multiple payments options or not only KCO
      title: formatMessage(messages.payment_step_title),
      component: PaymentOptions,
      stepMessage: formatMessage(messages.payment_step_message),
      // validationSchema: getValidationSchema(intlData, fields, [ValidationSchemaNames.billingAddress, ValidationSchemaNames.consentGroup])
      // handleNextStep: this.handlePaymentStep
    },
    {
      shouldRender: isOnlyKCO, // Only when Klarna Checkout
      title: formatMessage(messages.payment_step_title),
      component: KlarnaCheckout,
    },
  ];
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Steps/StepsList.ts